/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'window',
    'pip-common.utils',
    'plugin.tooltip',
    'breakpoints'
], function (
    $,
    Mustache,
    pip,
    pipEvents,
    window,
    pipCommonUtils,
    tooltip,
    breakpoints
) {
    var view = {
        selectors: {
            consumerCreditMessageContainer: '#consumer-credit-message-container',
            applyNowLink : '#credit-promo-apply-now',
            infoIcon: '#credit-info-icon'
        },
        templates: {
            creditMessage: $('#credit-promo-message__wrapper').html(),
            paymentEstimator: $('#payment-estimator__wrapper').html(),
            toolTip: $('#financing-details__wrapper').html()
        },
        render: {
            creditMessage: function renderCreditMessage() {
                return Mustache.render(view.templates.creditMessage, viewModel)
            },
            paymentEstimator: function renderPaymentEstimator() {
                return Mustache.render(view.templates.paymentEstimator, viewModel)
            },
            toolTipContent: function renderToolTipContent() {
                return Mustache.render(view.templates.toolTip, viewModel)
            }
        },
        updateDom: {
            creditMessage: function updateDomCreditMessage() {
                $(view.selectors.consumerCreditMessageContainer).html(view.render.creditMessage());
            },
            paymentEstimator: function updateDomPaymentEstimator() {
                $(view.selectors.consumerCreditMessageContainer).html(view.render.paymentEstimator());
            }
        },
        initEventListeners : function initEventListeners() {
            $(window.document).off('click', view.selectors.applyNowLink);
            $(window.document).on('click', view.selectors.applyNowLink, function(e){
                pipEvents.consumerCreditMessage.applyNowClicked.trigger();
            });
        },
        attachTooltips: function () {
            $(view.selectors.infoIcon).tooltip({
                type: 'click',
                position: 'bottom',
                content: view.render.toolTipContent(),
                width: (breakpoints.isActiveBreakpointEqualToOrSmallerThan('Medium')) ? 'medium' : 'large',
                closeButton: true,
                bestPosition: false,
                closeOnClick: true
            });
        },
        init: function init() {
            if (model.isValidPaymentEstimator) {
                view.updateDom.paymentEstimator();
                view.attachTooltips();
            } else {
                view.updateDom.creditMessage();
            }
            view.initEventListeners();
        }
    };
    var model = {
        init: function init() {
            model.isValidPaymentEstimator = false;
        },

    };
    var viewModel = {
        init : function init() {
            var mobileApplyNowUrl = window.THD.PaymentEstimator.defaultApplynowLinks('pip').mobileUrl;
            var desktopApplyNowUrl = window.THD.PaymentEstimator.defaultApplynowLinks('pip').desktopUrl;
            if (model.isValidPaymentEstimator) {
                var itemPrice = pip.products.primary.data.itemExtension.displayPrice;
                viewModel.displayPrice = parseFloat(itemPrice).toFixed(2);
                var isAppliance = (pip.experience === 'appliance');
                var estimatedPayments = itemPrice ? window.THD.PaymentEstimator.estimatedPayments(itemPrice, isAppliance) : '';
                viewModel.promotionTerm = estimatedPayments.promotionTerm ? estimatedPayments.promotionTerm : '';
                viewModel.monthlyPayment = estimatedPayments.monthlyPayment ? estimatedPayments.monthlyPayment : '';
                if (model.isPromotionPeriod) {
                    viewModel.promoStartDate = model.promoStartDate;
                    viewModel.promoEndDate = model.promoEndDate;
                    viewModel.isPromotionPeriod = true;
                }
                var peApplyLinks = window.THD.PaymentEstimator.paymentEstimatorApplynowLinks('pip', isAppliance);
                desktopApplyNowUrl = peApplyLinks.desktopUrl;
                mobileApplyNowUrl = peApplyLinks.mobileUrl;
                viewModel.isTestAndTargetEnabled = pip && pip.features && pip.features.paymentEstimatorTestAndTarget;
                viewModel.toolTipText = '6 MONTHS EVERY DAY FINANCING* ON PURCHASES OF $299 OR MORE';
                if (window.THD.PaymentEstimator.toolTipText) {
                    viewModel.toolTipText = window.THD.PaymentEstimator.toolTipText(isAppliance);
                }
            }
            viewModel.applynowUrl = (pip && pip.platform === "MOBILE") ? mobileApplyNowUrl : desktopApplyNowUrl;
        }
    };

    function shouldDisplayCreditPromoMessage() {
        var isDiscontinuedItem = pipCommonUtils.deepGet(pip,'products.primary.data.itemAvailability.discontinuedItem');
        return (pip.features.consumerCreditMessageEnabled && !isDiscontinuedItem);
    };
    function shouldDisplayPaymentEstimator() {
        var displayPrice = pipCommonUtils.deepGet(pip,'products.primary.data.itemExtension.displayPrice');
        var isMapPriceScenario = pipCommonUtils.deepGet(pip, 'products.primary.data.itemExtension.isMapPriceScenario');
        return (!isMapPriceScenario && pip.features.paymentEstimatorEnabled && displayPrice >= window.THD.PaymentEstimator.financeEligibleAmount());
    }
    function initPaymentEstimator() {
        model.isValidPaymentEstimator = true;
        var isAppliance = (pip.experience === 'appliance');
        var promoDates = (window.THD.PaymentEstimator.currentPromotionDates) ? window.THD.PaymentEstimator.currentPromotionDates(isAppliance) : "";
        if (promoDates && promoDates.promoStartDate) {
            model.isPromotionPeriod = true;
            model.promoStartDate = promoDates.promoStartDate;
            model.promoEndDate = promoDates.promoEndDate;
        }
    }
    function initConsumerCreditMessage() {
        if (shouldDisplayPaymentEstimator()) {
            initPaymentEstimator();
        }
        viewModel.init();
        view.init();
    }
    function loadEstimatorScript() {
        var fileVersion = pip.features.paymentEstimatorVersion || "v1.0.6";
        var fileUrl = (pip.env && (pip.env.toLowerCase() !== 'prod' && pip.env.toLowerCase() !== 'beta'))
          ? 'https://assets-qa.homedepot-static.com/paymentestimator/'+fileVersion+'/payment-estimator.js'
          : 'https://assets.homedepot-static.com/paymentestimator/'+fileVersion+'/payment-estimator.js';
        var head = document.querySelector("head");
        var script = document.createElement("script");
        script.setAttribute("src", fileUrl);
        script.onload = function () {
          if(window.THD.PaymentEstimator) {
            initConsumerCreditMessage();
          }
        };
        head.appendChild(script);
    };
    return {
        init: function () {
            if (shouldDisplayCreditPromoMessage()) {
                model.init();
                loadEstimatorScript();
            }
        },
        shouldDisplayCreditPromoMessage : shouldDisplayCreditPromoMessage,
        viewModel :viewModel,
        shouldDisplayPaymentEstimator: shouldDisplayPaymentEstimator,
        model: model,
        initPaymentEstimator: initPaymentEstimator
    }
})

}.call(window));